// extracted by mini-css-extract-plugin
module.exports = {"questionDescription":"question_questionDescription__3xFNl"};